import {logger} from './Logger';

/** Polyfill for ES2017 'Object.values' */
export const objectValues = (obj: any) => {
  return Object.keys(obj).map(function (key) {
    return obj[key];
  });
};

/**
 * Wraps property access with try/catch
 */
export function safeAccess<T>(access: () => T): T | undefined {
  try {
    return access();
  } catch (error) {
    logger.log(`safeAccess catched failed access on property: `, error);
    return undefined;
  }
}
